import React from "react";
import {DispositionIcon, EntityIcon} from "..";
import classNames from "classnames";
import {getDispositionColor} from "utils/disposition";
import {getEntityTypeIcon} from "utils/icons";
import css from "./ObservableIcon.module.scss";

/**
 * Aggregation of EntityIcon & DispositionIcon.
 */
const ObservableIcon = ({type, disposition, minimal = false}) => {
  const color = getDispositionColor(disposition);

  return (
    <div data-testid={"EntityList-ObservableIcon"} className={css.iconWrapper}>
      <DispositionIcon
        disposition={disposition}
        className={classNames(css.dispositionIcon, {
          [css.dispositionIconMinimal]: minimal
        })}
      />
      <EntityIcon
        icon={getEntityTypeIcon(type)}
        style={{color}}
        small={minimal}
      />
    </div>
  );
};

export default ObservableIcon;
